module.exports = __webpack_public_path__ + "static/car7-34cdcc3cb3ffff0574743e10a247fe88.png";